import React from "react";

const VettingLeftArrow = () => {
  return (
    <svg
      width="8"
      height="13"
      viewBox="0 0 8 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.166016 6.5L7.16602 12.5L7.16602 0.5L0.166016 6.5Z"
        fill="#333333"
      />
    </svg>
  );
};

export default VettingLeftArrow;
